import { OnlyMyTimesheetsCheckboxState } from './types';
import { ONLY_MY_TIMESHEETS_CHECKBOX_TOGGLE } from './constants';

export const initialState: OnlyMyTimesheetsCheckboxState = {
    checked: false
};

function onlyMyTimesheetsReducer(
    state: OnlyMyTimesheetsCheckboxState = initialState,
    action: any
): OnlyMyTimesheetsCheckboxState {
    switch (action.type) {
        case ONLY_MY_TIMESHEETS_CHECKBOX_TOGGLE: {
            return {
                ...state,
                checked: !state.checked
            };
        }
        default:
            return state;
    }
}

export default onlyMyTimesheetsReducer;
